// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select.inputMain.form-select {
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #D0566E;
  outline: none;
  width: 170px;
  border-radius: 0px;
}

select.inputMain.form-select:focus {
  outline: none;
  border-bottom: 1px solid var(--hover-color) !important;
}

input.inputMain.form-control {
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #D0566E;
  outline: none;
  width: 268px;
  padding: 0px;
  border-radius: 0px;
  line-height: 1px;
}

input.inputMain::placeholder {
  color: var(--text-gray-color);
}

input.inputMain.addLeads.form-control {
  width: 170px;
  padding-top: 10px;
  padding-bottom: 4px;
}

input.inputMain.search.form-control {
  width: 50%;
}

.input-label.success.form-text {
  font-size: 18px;
  font-weight: 700;
  color: var(--success-green-color);
}

.input-label.error.form-text {
  font-size: 18px;
  font-weight: 700;
  color: var(--error-red-color);
}

.input-label.cabin.form-text {
  color: #000000;
}

.input-label.form-text {
  font-size: 16px;
  font-weight: 400;
}

.port-text-font.form-text, .discount-text-font.form-text {
  font-size: 12px;
  font-weight: 400;
  margin-top: 0px;
}

.discount-text-font.form-text {
  color: #17A300;
}

.textBox {
  display: flex;
  justify-content: flex-end;
}

.mainBtn {
  background: var(--main-btn) !important;
  color: var(--background-color) !important;
  border: none !important;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  transition: background-color 0.3s ease !important;
  text-transform: none !important;
}

.mainBtn:hover {
  background-color: #b63f48 !important;
}

.mainBtn.loginBtn {
  max-width: 150px;
}

.mainBtn.createBtn {
  width: 10rem;
  max-height: 2.2rem;
}

.mainBtn.Grey-Btn {
  width: 10rem;
  background: var(--text-grayBtn-color) !important;
  color: var(--primary-font-color) !important;
}

.mainHead {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

button#RFS-StepButton.active {
  background-color: var(--hover-color) !important;
}

button#RFS-StepButton.completed {
  background-color: var(--hover-color) !important;
}

.main-heading.form-text {
  font-size: 20px;
  font-weight: 700;
}

.inputMain.quotation.form-select {
  width: 465px !important;
}

.inputMain.select-guest.form-select {
  max-width: 75px;
}

/* .quotation-checkbox label {
  color: black;
} */
.quotation-checkbox .form-check-input:checked {
  border-color: var(--hover-color);
  background-color: var(--hover-color);
}

.form-check-input:focus {
  border-color: #ddd !important;
  box-shadow: none !important;
}

small.input-label.quotation.form-text {
  font-size: 14px;
  color: #7A7A7A;
}

.input-label.success.text.form-text {
  font-size: 14px;
}

.cabin-view {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.input-label.cabin.form-text {
  font-size: 16px;
  font-weight: 500;
}

.input-label.cabinPrice.form-text {
  font-size: 20px;
  font-weight: 500;
  color: var(--primary-font-color);
  display: flex;
  justify-content: flex-end;
}

.mainBtn.cabinBtn {
  height: 36px !important;
  width: 36px;
}

.form-control:disabled {
  background-color: none !important;
}

/* base Classes end */
/* quotation start */
.select-quest-box.row {
  padding: 0px 0px 16px 0px;
  border-bottom: 1px solid gainsboro;
  flex-wrap: wrap;
}

.quotation-checkbox.form-check {
  font-size: 14px;
}

.quotation-heading.form-text {
  font-size: 18px;
  font-weight: 700;
}

.cabin-pricing {
  cursor: pointer;
  border-bottom: 1px solid var(--text-gray-color);
}
.cabin-pricing .cabin-detail-wrapper {
  border-bottom: 1px solid #ddd;
}
.cabin-pricing .cabin-detail-wrapper:has(.cabin-guest-wrapper) {
  padding-bottom: 0 !important;
}

.collapsed-content {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
}

.cabinContent {
  display: flex;
  gap: 9px;
  justify-content: flex-end;
}

.input-label.error.text.form-text {
  font-size: 14px;
}

.selling-box {
  overflow-x: hidden;
}

.selling-box::-webkit-scrollbar {
  display: none;
}

.selling-box {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.input-label.price-text.form-text {
  font-size: 16px;
  font-weight: 700;
}

.input-label.select-guest.form-text {
  font-weight: 500;
  display: flex;
  color: var(--hover-color);
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.invoice {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

/* quotation end */
.stepStyleActive {
  color: var(--hover-color);
}

.stepperBoxContent {
  min-width: 60%;
}

.stepperBoxHead {
  display: flex;
  justify-content: center;
}

/* basic detail page css  */
.basic-detail-page {
  background-color: var(--background-color);
}

.btn-box {
  padding-right: 44px;
  display: flex;
  justify-content: flex-end;
}

.card-content.card {
  padding: 28px;
}

.autoComplete {
  display: flex;
  gap: 131px;
}

.autoComplete-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.addleads {
  margin-right: 31px;
}

.select-box {
  display: flex;
  align-items: center;
  gap: 22px;
}

tr.tableRow {
  cursor: pointer;
}

tr.tableRow:hover {
  background: #f3f3f3;
}

thead {
  line-height: 2;
  font-weight: 400 !important;
  color: #7A7A7A !important;
  margin-bottom: 4px !important;
  border-bottom: 1px solid #d7d7d7 !important;
}

small.input-label-check.form-text {
  font-size: 12px;
}

.check-num {
  display: flex;
  /* font-size: 21px; */
  gap: 6px;
  padding-top: 12px;
  align-items: center;
}

.status.Active.form-text {
  font-size: 17px;
  font-weight: 500;
  color: #17A300;
}

.status.Inactive.form-text {
  font-size: 17px;
  margin-top: 14px;
  font-weight: 500;
  color: #D40D0D;
}

.card-content.preview.card {
  padding: 7px 28px;
}

.closeBtnBox {
  display: flex;
  justify-content: flex-end;
}

.moreInfo {
  padding: 24px;
}

.special-services {
  display: flex;
  justify-content: space-between;
  padding: 4px 11px;
  margin: 10px 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Login Page Css  start */
.loginPage {
  height: 100%;
  width: 100%;
}

.loginPageContent {
  padding: 47px 40px;
  position: absolute;
  top: 0;
  background: #fff;
  border-radius: 23px;
  margin: 150px;
}

.carouselBox {
  position: relative;
}

.fontText.back {
  color: var(--text-darkgray-color);
  line-height: 2;
}

.fontText.back:hover {
  color: var(--hover-color);
}

.imageBox {
  margin: 4px 54px;
}

.loginInputsBox {
  background-color: var(--background-color);
  padding: 37px 0px 28px 0px;
  border-radius: 27px;
  margin: 61px;
  width: 348px;
}

.loginInputs {
  background: var(--background-color);
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.detailBox.select {
  display: flex;
  align-items: baseline;
  gap: 21px;
}

.selectInputs {
  width: 185px;
}

.fontText {
  text-align: end;
  color: var(--text-gray-color) !important;
  cursor: pointer;
  font-size: 14px !important;
}

.inputHead {
  font-size: 16px;
  color: var(--primary-font-color);
  font-family: var(--dm-font);
}

.fontText.text {
  text-align: start;
  font-size: 18px;
  font-weight: 500;
}

.fontText.resetText {
  font-size: 18px;
  color: var(--text-darkgray-color);
  text-align: justify;
}

.textInputs .MuiOutlinedInput-root fieldset {
  border-color: transparent; /* Remove outline */
}

.textInputs .MuiOutlinedInput-root:hover fieldset {
  border-color: var(--hover-color); /* Change hover color */
}

.textInputs {
  margin-top: 20px !important;
}

.textInputs.text {
  margin-top: 9px;
  color: var(--primary-font-color);
}

.textInputs .MuiInput-underline:before {
  border-bottom: 1px solid var(--hover-color);
}

.textInputs .MuiInput-underline:hover:before {
  border-bottom: 1px solid var(--hover-color);
}

.textInputs .MuiInput-underline:hover:after {
  border-bottom: 2px solid var(--hover-color) !important;
  transition: border-bottom-color 0.2s ease-in-out;
}

.textInputs .MuiInput-underline:after {
  border-bottom: 1px solid var(--hover-color);
}

.textInputs .MuiInput-root:hover .MuiInput-underline:after {
  border-bottom-color: var(--hover-color) !important;
}

.textInputs .MuiInput-underline:before {
  border-bottom: 1px solid var(--hover-color);
}

.textInputs .MuiInput-underline:hover:before {
  border-bottom: 1px solid var(--hover-color) !important;
}

.customCheckbox {
  color: var(--text-gray-color) !important;
}

.customCheckbox.Mui-checked {
  color: var(--text-gray-color) !important;
}

.rememberMe {
  display: flex;
  align-items: center;
  margin: 10px 0;
  color: var(--text-gray-color);
}

.loginContent {
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin: 0px 32px 0px 30p;
}

.btnBox {
  display: flex;
  justify-content: flex-end;
  margin-top: 34px;
}

/* Responsive Layout */
@media (max-width: 768px) {
  .login-page {
    padding: 50px 10px;
  }
  .loginInputsBox {
    margin: 20px 10px;
  }
}
.headerContent {
  background: linear-gradient(to right, var(--secondary-color), var(--primary-color));
  height: 107px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 28px 41px 1px 26px;
}

.basicDetailPage {
  padding: 9px 74px;
}

.basicDetailContent {
  display: flex;
  gap: 68px;
  padding-top: 65px;
}

.textInputs.search {
  width: 50%;
}

.textInputs.profile {
  margin-top: 0px;
}

.rememberMe.text {
  margin: 6px 0px 0px -23px;
}

.textHead {
  font-size: 14px;
}

.form-text.errorText {
  font-size: 13px;
  color: red;
  max-width: 268px;
}

.inputSection {
  max-width: 268px;
}

.headText {
  color: var(--text-darkgray-color);
  text-align: end;
  margin-top: 40px;
}

/* Stepper Css Start  */
.stepperBox {
  width: 100%; /* make the box take up the full width of the container */
}

.stepperBoxHeader {
  width: 0%;
}

/* .selectInputs .MuiSelect-root {
  color: #6F1F67; 
} */
.selectInputs input {
  caret-color: white; /* Change caret color */
  color: white; /* Change text color */
}

.selectInputs .MuiSelect-icon {
  color: gray;
}

.mainLogo {
  padding: 33px;
  margin: 0px 25px;
  cursor: pointer;
}

/* Itenerary SelectionPage css     */
.itenerarySelectionPage {
  padding: 9px 53px;
}

.selectInputs.multiSelect {
  max-width: 165px;
}

.itenerarySelectionContent {
  display: flex;
  gap: 3px;
}

.iteneraryText {
  font-size: 22px !important;
  font-weight: 600 !important;
  margin-top: 19px !important;
}

.searchBox {
  /* border-bottom: 1px solid var(--hover-color); */
  margin-top: 18px;
  box-shadow: 0px 5px 5px -5px rgba(208, 86, 110, 0.5);
}

td.tableContent {
  padding-bottom: 12px;
}

th.tableContent {
  font-weight: 400;
}

.searchHead {
  justify-content: space-between;
  display: flex;
  background-color: #F9FFF2;
  padding: 6px 26px;
}

.inputHead.dataText {
  font-weight: 600;
}

.searchDataContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  color: var(--primary-font-color);
  background-color: #F9FFF2;
  padding: 21px 21px;
  margin: 4px 0px;
}

.dateBox {
  display: flex;
  gap: 5px;
  align-items: center;
}

.basic-detail-page thead {
  border-bottom: 1px solid lightgray;
}

.searchHide {
  padding: 7px 27px;
  color: var(--text-darkgray-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordianBar {
  display: flex;
  color: #C1517A;
  font-weight: 500;
  cursor: pointer;
}

.accordianBar.hide {
  display: flex;
  font-weight: 500;
  cursor: pointer;
  color: var(--primary-font-color);
}

.accordianBar:hover {
  color: #852b4c;
}

.grayBtn {
  width: 150px !important;
  background: var(--text-grayBtn-color) !important;
  color: var(--primary-font-color) !important;
}

.status {
  font-weight: 500;
}

.status .confirmed {
  color: #17A300;
  font-weight: 500;
}

.status .onhold {
  color: #D07D00;
  font-weight: 500;
}

.status .Cancelled {
  color: #D40D0D;
  font-weight: 500;
}

.status .Rescheduled {
  color: #0D2DD4;
  font-weight: 500;
}

.closeTag {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  cursor: pointer;
  margin-bottom: 23px;
}

.closeIcon {
  background-color: beige;
  color: gray;
}

.dateTxt {
  font-size: 14px;
}

.btnBoxModal {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modalBtn {
  width: 100% !important;
}

.modalBox {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.modalContent {
  margin: 1px 74px;
}

.timelineMainHead {
  display: flex;
  gap: 34%;
  margin: 52px 75px;
}

.timelineHead {
  font-size: 20px;
  font-weight: 500;
}

.fontText.modalText {
  text-align: start;
}

.timelineMain {
  display: flex;
  gap: 29px;
  margin: -23px 14px 0px 85px;
}

.timelineMain:hover {
  color: var(--hover-color) !important;
  cursor: pointer;
}

.timelineMainContent {
  display: flex;
  gap: 25px;
}

.dateBox.iconLogo {
  align-items: end;
}

/* profile page css */
.profileContent {
  margin: 7px 31px;
}

/* create Staff css */
.createStaffContent {
  margin: 7px 31px;
  height: 100vh;
}

.inputHead.headTextt {
  font-weight: 500;
}

.selectInputs.createSelect {
  width: 100%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.editIcon {
  cursor: pointer;
  color: darkgray;
}

.MuiDataGrid-withBorderColor {
  outline: none !important;
}

.MuiDataGrid-cell.MuiDataGrid-cell--textLeft.MuiDataGrid-withBorderColor {
  outline: none !important;
}

.inputHead.permission {
  padding: 9px;
}

.rolesCheck {
  color: var(--hover-color) !important;
}

.rolesCheck.Mui-checked {
  color: var(--hover-color) !important;
}

.headerProfile {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}

.MuiDataGrid-columnHeaders.MuiDataGrid-withBorderColor.css-y599qu {
  background: #f3f3f3 !important;
}

/* add lead details container */
.lead-details {
  background: #fff;
  height: 170px;
  margin-top: 40px !important;
  border-radius: 7px;
  margin-right: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  border: 1px solid rgba(122, 122, 122, 0.4039215686);
}

.lead-details:hover {
  border: 1px solid #DB686E;
}

.lead-details-icon {
  font-size: 50px !important;
  color: #3A3A3A;
}

.lead-details-icon.active,
.lead-details-icon:hover {
  font-size: 50px !important;
  color: #3A3A3A;
}

.lead-details:hover .lead-details-icon {
  color: #DB686E;
}

.lead-details h3 {
  font-weight: 700;
  font-size: 58px;
}

.lead-details h6 {
  font-weight: 500;
  font-size: 15px;
}

.lead-details:hover h6,
.lead-details:hover h3 {
  color: #DB686E;
}

/* add lead details container first */
.lead-details-first {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  height: 170px;
  margin-top: 40px !important;
  border-radius: 7px;
  margin-right: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  border: 1px solid rgba(122, 122, 122, 0.4039215686);
}

.lead-details-first:hover {
  border: 1px solid #DB686E;
}

.lead-details-first-icon {
  font-size: 50px !important;
  color: #ffffff;
}

.lead-details-first-icon.active,
.lead-details-icon:hover {
  font-size: 50px !important;
  color: #ffffff;
}

.lead-details-first:hover .lead-details-first-icon {
  color: #ffffff;
}

.lead-details-first h3 {
  font-weight: 700;
  font-size: 58px;
  color: #ffffff;
}

.lead-details-first h6 {
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

.lead-details-first:hover h6,
.lead-details-first:hover h3 {
  color: #ffffff;
}

/* dashboard page */
.dashboard-header-search {
  display: flex;
  border-bottom: 1px solid rgba(85, 85, 85, 0.2862745098);
  padding: 5px;
  align-items: center;
  justify-content: flex-start;
  width: 60% !important;
}

.dashboard-header-search.leads {
  border-bottom: 1px solid var(--hover-color);
  max-width: 50%;
}

.dashboard-header-search-icon {
  font-size: 20px !important;
}

.dashboard-header-search-input {
  width: 100%;
  margin-left: 10px;
  border: none;
  background: none;
  color: #7A7A7A;
}

.dashboard-header-search-input:active,
.dashboard-header-search-input:focus,
.dashboard-header-search-input:focus-visible {
  border: none !important;
  outline: none;
}

.a {
  color: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
}

.hidden {
  transform: translateX(-100%);
}

.visible {
  transform: translateX(0);
}

.sidebar .nav-link:hover {
  color: #fff;
}

/* Itinerary cards  */
.recent-card-content {
  display: flex;
  border: 1px solid #DDDDDD;
  border-radius: 7px;
  flex-direction: column;
  background: #FCFCFC;
  position: relative;
  top: 18px;
}

.recent-card-content-footer.row {
  margin: 0px 8px;
}

.recent-card-content-bottom.col-sm-4.col-12 {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
}

.recent-card-content-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 7px;
  padding-top: 5px;
  border-bottom: 1px solid #DDDDDD;
  background-color: #F9FFF2;
}

.recent-card-content-header div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recent-card-content-header div h3:first-child {
  color: #92278F;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.recent-card-content-header div span {
  color: #17A300;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.recent-card-content-header h3 {
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
}

h3.status-text {
  color: #17A300 !important;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.recent-card-content-header span {
  margin-left: 10px;
}

.recent-card-content-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.recent-card-content-body-box {
  display: flex;
  gap: 7px;
  align-items: center;
}

.recent-card-content-body-box span {
  color: #7A7A7A;
  display: flex;
  gap: 8px;
  align-items: center;
}

.container-fluid {
  --bs-gutter-x: 0 !important;
  overflow-x: hidden !important;
}

.recent-card-content-body-box-details-btn {
  border: none;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  padding: 7px 13px;
  color: #3A3A3A;
}

.recent-card-content-body-bottom {
  display: flex;
  width: 80%;
  justify-content: space-between;
  padding: 20px;
}

.recent-card-content-body-bottom-box {
  display: flex;
  flex-direction: column;
}

.recent-card-content-body-bottom-box span {
  display: flex;
  flex-direction: column;
  color: #7A7A7A;
  font-size: 14px;
}

span.card-content {
  font-size: 14px;
  font-weight: 700;
}

/*collapsible  side bar*/
.container-sidebar {
  display: flex;
}

main {
  width: 100%;
  background: #F7F7F7;
  padding: 0px 26px;
}

.sidebar {
  position: relative;
  background: #fff;
  color: #000;
  height: 100vh;
  width: 250px;
  transition: all 0.04s ease-in-out;
}

.top_section {
  display: flex;
  align-items: center;
  padding: 20px 15px;
  margin-bottom: 20px;
}

.logo {
  font-size: 30px;
}

.bars {
  display: flex;
  font-size: 25px;
  margin-left: 50px;
  position: unset;
  left: 68%;
}

.link {
  color: #3A3A3A;
  padding: 10px 15px;
  border-radius: 5px;
  width: 100% !important;
  gap: 12px;
  text-align: center;
  display: flex;
  /* align-items: center; */
  height: 40px;
  text-decoration: none;
  cursor: pointer;
}

.link:hover {
  background: #fff;
  color: var(--hover-color);
}

.link.active {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  color: #fafafa;
}

.menu-item::hover {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  display: flex;
  justify-content: center;
  padding: 20px;
}

.icon, .link_text {
  font-size: 14px;
}

.custom-slider {
  width: 70%;
  margin: 0 auto;
}

.itneries-select {
  border: none !important;
  border-radius: 0 !important;
  border-bottom: 1px solid var(--hover-color) !important;
  /* padding: 0 !important;
  margin-top: 7px; */
  position: relative;
  top: 22%;
  color: #b4b3b3 !important;
  font-size: 16px !important;
}

select.itneries-select.form-select:focus {
  outline: none; /* Remove default focus outline */
  border-bottom: 1px solid var(--hover-color) !important; /* Maintain custom border-bottom */
}

.select-label {
  font-size: 16px !important;
  font-weight: 400;
  color: #3A3A3A;
}

.form-select:focus {
  border: none !important;
  outline: 0;
}

.itneries-links {
  display: flex;
  gap: 15px;
  margin-left: 20px;
  align-items: center;
}
.itneries-links span {
  width: 41px;
  height: 40px;
}

.nav-link {
  border: 1px solid rgba(197, 197, 197, 0.5019607843) !important;
  color: #BBBBBB !important;
}

/* select nights tabs*/
.selected-tabs {
  background-color: #ffffff !important;
  border: 1px solid rgba(197, 197, 197, 0.5019607843) !important;
  margin-left: 10px;
  color: #BBBBBB !important;
  padding: 8px 11px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.selected-tabs-active {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  border: none !important;
  margin-left: 10px;
  color: #ffffff !important;
  padding: 8px 11px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.itneries-links-chips {
  display: flex;
  gap: 5px;
  margin-top: 25px;
}

.itneries-links-chips p {
  padding: 4px 11px;
  background-color: rgba(155, 155, 155, 0.1725490196);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}

.itneries-button-check-availibity {
  display: flex;
  align-items: center;
  justify-content: center;
}

.itneries-button-check-availibity-button {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) !important;
  border: 0;
  border: none !important;
  font-size: 16px;
}

.itneries-button-preview-button {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: flex-end;
  position: relative;
  top: 20%;
}

.itneries-button-check-availibity a {
  width: auto;
  height: auto;
}

.recent-card-content-itnery-body.col-sm-9.col-12 {
  display: flex;
  justify-content: space-between;
  padding: 13px 33px;
}

.itneries-table-card-top {
  display: flex;
  border-bottom: 1px solid rgba(197, 197, 197, 0.5019607843);
  width: 100% !important;
  justify-content: space-between;
  align-items: center;
}

.itneries-table-card-top h5 {
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  margin-top: 8px !important;
}

.itneries-table-item {
  overflow: hidden;
  border-radius: 2px;
  box-sizing: border-box;
}

.itneries-table-card-top-span-01 {
  padding: 10px 34px;
  height: 100%;
  background-color: #C8F5FF;
  font-weight: 500;
  text-transform: capitalize;
  color: #1E1E1E;
  font-size: 16px;
  margin: 0;
}

.itneries-table-card-top-span-02 {
  padding: 10px 34px;
  height: 100%;
  font-weight: 500;
  background-color: #F6C1FF !important;
  color: #1E1E1E;
  font-size: 16px;
}

.exchange-destination-icon {
  cursor: pointer;
  padding: 4px;
  position: relative;
}

.itneries-table-checkbox {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.itneries-table-card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.itneries-table-card-bottom span {
  padding: 10px;
  color: #7A7A7A;
  font-size: 16px;
}

.itneries-table-card-bottom span:nth-child(2) {
  color: #C35379;
}

.itneries-table-card-bottom span:nth-child(5) {
  color: #92278F;
}

.itneries-table-head {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  background: #F8F7F7;
  border-radius: 6px;
  height: 30px;
  margin-bottom: 15px;
}

.itneries-table-head span {
  font-size: 14px;
  color: #3A3A3A;
}

/* react date range picker css custmomization*/
.rdrDateRangeWrapper {
  z-index: 9999;
  position: absolute;
  width: 700px;
  border: 1px solid #f7f7f7;
  margin-top: 20px;
  box-shadow: #f7f7f7;
}

.rdrDefinedRangesWrapper {
  background-color: blue;
}

.select-range-button {
  position: relative;
  top: 38%;
  display: flex;
}

.select-range-button input {
  border-radius: none;
  border: none;
  width: fit-content;
  height: 24px;
  border-bottom: 1px solid var(--hover-color);
}

.select-range-button span {
  display: flex;
  justify-content: right;
}

/* header right side profile popup  */
.profile-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 0;
  width: 100%;
  height: 100%;
  top: 32%;
  cursor: pointer;
  right: 10px;
  transition: opacity 0.3s ease-in-out;
}

.profile-popup-content {
  background-color: #fff;
  padding: 10px;
  border-radius: 3px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 9999;
  font-size: 14px;
  color: #3A3A3A;
}

.profile-popup-content p {
  margin-bottom: 8px !important;
  gap: 7px;
  display: flex;
}

/* preview modal detail */
.preview-model-details {
  display: flex;
}

.preview-model-details-box {
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
}

.preview-model-details-box span:first-child {
  font-weight: bold;
  text-transform: capitalize;
  font-size: 17px;
}

.preview-model-details-box span:nth-child(2) {
  font-weight: 500;
  line-height: 30px;
}

.preview-model-visite {
  display: flex;
}

.preview-model-visite-item {
  padding-right: 40px;
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.preview-model-visite-item span {
  font-size: 14px;
  font-weight: 400;
}

.preview-model-visite-item svg {
  width: 20px;
  height: 20px;
}

.hr-color {
  border: 1px solid rgba(138, 138, 138, 0.545);
}

.model-details-cards {
  display: flex;
}

.model-details-cards-box {
  padding-top: 20px;
  padding-right: 90px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.model-details-cards-box::after {
  content: "";
  position: absolute;
  width: 40px;
  height: 1px;
  background-color: rgba(15, 10, 10, 0.522);
  top: 35px;
  right: 22px;
}

.model-details-cards-box:last-child:after {
  display: none;
}

.model-details-cards-box svg {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.model-available-cabins h4 {
  font-size: 18px;
  font-weight: 700;
  color: rgba(27, 18, 18, 0.8117647059);
}

.model-available-cabins {
  display: flex;
  gap: 40px;
  justify-content: space-between;
}

.model-available-cabins-box {
  display: flex;
  flex-direction: column;
}

.model-available-cabins-box span:first-child {
  font-size: 18px;
  font-weight: 500;
  color: #e12d6f;
}

.model-available-cabins-box span:nth-child(2) {
  color: #b91d1d;
  font-size: 14px;
}

.model-available-cabins-box span.more-than-10 {
  color: #17A300;
}

input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
  accent-color: #673ab7;
}

.preview-itneries-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  top: 20px;
  padding: 0px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.preview-itneries-buttons-button {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) !important;
  border: 0;
  border: none !important;
  font-size: 16px;
  padding: 10px 50px !important;
}

/* end */
/* ---success modal---*/
.success-modal-button-container {
  display: flex;
  justify-content: center;
  padding: 29px 10px 17px 10px;
  gap: 20px;
  margin-bottom: 20px;
}

.success-modal-button-container button:nth-child(1) {
  background-color: rgb(228, 228, 228);
  padding: 10px 26px 10px;
  font-size: 13px;
  border: none !important;
  color: #3a3a3a;
}

.success-modal-button-container button:nth-child(2) {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  border: none !important;
  padding: 10px 26px 10px;
  font-size: 13px;
}

/* All bookings tabs */
.nav-tabs .nav-link {
  border-radius: 6px;
  background: #e9e9e9;
  color: #3A3A3A !important;
  font-size: 16px;
}

.nav-tabs {
  --bs-nav-tabs-border-width: none !important ;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);
  color: #ffffff !important;
  font-size: 16px;
  border: none !important;
}

.all-bookings-active {
  background: none;
}

.nav-link:focus-visible {
  box-shadow: none !important;
}

.form-control:disabled {
  background: none !important;
}

input.inputMain.form-control:disabled {
  background: none !important;
}

.form-select:focus {
  outline: 0;
  box-shadow: none !important;
}

.itneries-select option {
  background-color: transparent;
  border: none !important;
  color: black;
}

.calenderIcon {
  position: absolute;
  right: 5px;
}

select.itneries-select.valueSelect.form-select {
  color: var(--primary-font-color) !important;
}

.error-msg-text {
  font-size: 12px;
  color: red;
  padding: 3px;
}

.roundClass {
  display: flex;
  align-items: center;
  gap: 6px;
}

.booking-text {
  color: #92278F;
  font-size: 16px;
  font-weight: 700;
  margin-top: 15px;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddLeads/stepThree/style.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sDAAA;AACF;;AACA;EACE,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,6BAAA;AAGF;;AADA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,UAAA;AAKF;;AAHA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;AAMF;;AAJA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAOF;;AALA;EACE,cAAA;AAQF;;AANA;EACE,eAAA;EACA,gBAAA;AASF;;AAPA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAUF;;AAPA;EACE,cAAA;AAUF;;AAPA;EACE,aAAA;EACA,yBAAA;AAUF;;AARA;EACE,sCAAA;EACA,yCAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,mDAAA;EACA,iDAAA;EACA,+BAAA;AAWF;;AARA;EACE,oCAAA;AAWF;;AARA;EACE,gBAAA;AAWF;;AATA;EACE,YAAA;EACA,kBAAA;AAYF;;AAVA;EACE,YAAA;EACA,gDAAA;EACA,2CAAA;AAaF;;AAVA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAaF;;AAXA;EACE,+CAAA;AAcF;;AAZA;EACE,+CAAA;AAeF;;AAbA;EACE,eAAA;EACA,gBAAA;AAgBF;;AAdA;EACE,uBAAA;AAiBF;;AAfA;EACE,eAAA;AAkBF;;AAhBA;;GAAA;AAKA;EACE,gCAAA;EACA,oCAAA;AAiBF;;AAfA;EACE,6BAAA;EACA,2BAAA;AAkBF;;AAhBA;EACE,eAAA;EACA,cAAA;AAmBF;;AAjBA;EACE,eAAA;AAoBF;;AAlBA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAqBF;;AAnBA;EACE,eAAA;EACA,gBAAA;AAsBF;;AApBA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,yBAAA;AAuBF;;AArBA;EACE,uBAAA;EACA,WAAA;AAwBF;;AAtBA;EACG,iCAAA;AAyBH;;AArBA,qBAAA;AAEA,oBAAA;AACA;EACE,yBAAA;EACA,kCAAA;EACA,eAAA;AAuBF;;AArBA;EACE,eAAA;AAwBF;;AAtBA;EACE,eAAA;EACA,gBAAA;AAyBF;;AAvBA;EACE,eAAA;EACA,+CAAA;AA0BF;AAzBE;EACE,6BAAA;AA2BJ;AA1BI;EACE,4BAAA;AA4BN;;AAxBA;EACE,0CAAA;AA2BF;;AAzBA;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AA4BF;;AA1BA;EACE,eAAA;AA6BF;;AA3BA;EAEE,kBAAA;AA6BF;;AA3BA;EACE,aAAA;AA8BF;;AA3BA;EACE,wBAAA;EACA,qBAAA;AA8BF;;AA5BA;EACE,eAAA;EACA,gBAAA;AA+BF;;AA7BA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAgCF;;AA7BA;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;AAgCF;;AA9BA,kBAAA;AAGA;EACE,yBAAA;AA+BF;;AA7BA;EACE,cAAA;AAgCF;;AA9BA;EACE,aAAA;EACA,uBAAA;AAiCF;;AA9BA,2BAAA;AACA;EACA,yCAAA;AAiCA;;AA/BA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;AAkCF;;AAhCA;EACE,aAAA;AAmCF;;AAjCA;EACE,aAAA;EACA,UAAA;AAoCF;;AAlCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAqCF;;AAnCA;EACE,kBAAA;AAsCF;;AApCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAuCF;;AArCA;EACE,eAAA;AAwCF;;AAtCA;EACE,mBAAA;AAyCF;;AAvCA;EACE,cAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2CAAA;AA0CF;;AAtCA;EACE,eAAA;AAyCF;;AAvCA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AA0CF;;AAxCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA2CF;;AAzCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA4CF;;AAzCA;EACE,iBAAA;AA4CF;;AAzCA;EACE,aAAA;EACA,yBAAA;AA4CF;;AA1CA;EACE,aAAA;AA6CF;;AA3CA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;AA8CF;;AA3CA,0BAAA;AACA;EACE,YAAA;EACA,WAAA;AA8CF;;AA5CA;EACE,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AA+CF;;AA7CA;EACE,kBAAA;AAgDF;;AA9CA;EACE,iCAAA;EACA,cAAA;AAiDF;;AA/CA;EACE,yBAAA;AAkDF;;AAhDA;EACE,gBAAA;AAmDF;;AAhDA;EACE,yCAAA;EACA,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAmDF;;AAhDA;EACE,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAmDF;;AAjDA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAoDF;;AAlDA;EACE,YAAA;AAqDF;;AAnDA;EACE,eAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;AAsDF;;AApDA;EACE,eAAA;EACA,gCAAA;EACA,2BAAA;AAuDF;;AArDA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AAwDF;;AAtDA;EACE,eAAA;EACA,iCAAA;EACA,mBAAA;AAyDF;;AAtDA;EACE,yBAAA,EAAA,mBAAA;AAyDF;;AAtDA;EACE,gCAAA,EAAA,uBAAA;AAyDF;;AAtDA;EACE,2BAAA;AAyDF;;AAvDA;EACE,eAAA;EACA,gCAAA;AA0DF;;AAxDA;EACE,2CAAA;AA2DF;;AAzDA;EACE,2CAAA;AA4DF;;AAzDA;EACE,sDAAA;EACA,gDAAA;AA4DF;;AAzDA;EACE,2CAAA;AA4DF;;AAzDA;EACE,kDAAA;AA4DF;;AA1DA;EACE,2CAAA;AA6DF;;AA3DA;EACE,sDAAA;AA8DF;;AA3DA;EACE,wCAAA;AA8DF;;AA3DA;EACE,wCAAA;AA8DF;;AA5DA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AA+DF;;AA5DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;AA+DF;;AA1DA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AA6DF;;AA1DA,sBAAA;AACA;EACE;IACE,kBAAA;EA6DF;EA1DA;IACE,iBAAA;EA4DF;AACF;AAzDA;EACE,mFAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;AA2DF;;AAzDA;EACE,iBAAA;AA4DF;;AAzDA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AA4DF;;AA1DA;EACE,UAAA;AA6DF;;AA3DA;EACE,eAAA;AA8DF;;AA5DA;EACE,yBAAA;AA+DF;;AA7DA;EACE,eAAA;AAgEF;;AA9DA;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AAiEF;;AA/DA;EACE,gBAAA;AAkEF;;AAhEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;AAmEF;;AAhEA,uBAAA;AAEA;EAEE,WAAA,EAAA,yDAAA;AAiEF;;AA/DA;EACE,SAAA;AAkEF;;AAhEA;;GAAA;AAIA;EACE,kBAAA,EAAA,uBAAA;EACA,YAAA,EAAA,sBAAA;AAkEF;;AA/DA;EACE,WAAA;AAkEF;;AAhEA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;AAmEF;;AAhEA,oCAAA;AAEA;EACE,iBAAA;AAkEF;;AAhEA;EACE,gBAAA;AAmEF;;AAjEA;EACE,aAAA;EACA,QAAA;AAoEF;;AAlEA;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;AAqEF;;AAlEA;EACE,iDAAA;EACA,gBAAA;EACA,oDAAA;AAqEF;;AAnEA;EACE,oBAAA;AAsEF;;AApEA;EACE,gBAAA;AAuEF;;AApEA;EACE,8BAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAuEF;;AArEA;EACE,gBAAA;AAwEF;;AAtEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAyEF;;AAvEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA0EF;;AAxEA;EACE,kCAAA;AA2EF;;AAxEA;EACE,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA2EF;;AAzEA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA4EF;;AA1EA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA6EF;;AA3EA;EACE,cAAA;AA8EF;;AA3EA;EACE,uBAAA;EACA,gDAAA;EACA,2CAAA;AA8EF;;AA5EA;EACE,gBAAA;AA+EF;;AA7EA;EACE,cAAA;EACA,gBAAA;AAgFF;;AA9EA;EACE,cAAA;EACA,gBAAA;AAiFF;;AA/EA;EACE,cAAA;EACA,gBAAA;AAkFF;;AAhFA;EACE,cAAA;EACA,gBAAA;AAmFF;;AAhFA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAmFF;;AAjFA;EACE,uBAAA;EACA,WAAA;AAoFF;;AAlFA;EACE,eAAA;AAqFF;;AAnFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAsFF;;AApFA;EACE,sBAAA;AAuFF;;AArFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAwFF;;AAtFA;EACE,gBAAA;AAyFF;;AAvFA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;AA0FF;;AAxFA;EACI,eAAA;EACA,gBAAA;AA2FJ;;AAzFA;EACE,iBAAA;AA4FF;;AAzFA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;AA4FF;;AA1FA;EAEE,oCAAA;EACA,eAAA;AA4FF;;AA1FA;EACE,aAAA;EACA,SAAA;AA6FF;;AA3FA;EACE,gBAAA;AA8FF;;AA1FA,qBAAA;AAEA;EACE,gBAAA;AA4FF;;AAzFA,qBAAA;AACA;EACE,gBAAA;EACA,aAAA;AA4FF;;AAzFA;EACE,gBAAA;AA4FF;;AAzFA;EACE,WAAA;AA4FF;;AAzFA;;EAEI,wBAAA;EACA,SAAA;AA4FJ;;AA1FA;EACE,eAAA;EACA,eAAA;AA6FF;;AA3FA;EACE,wBAAA;AA8FF;;AA5FA;EACE,wBAAA;AA+FF;;AA7FA;EACE,YAAA;AAgGF;;AA9FA;EACA,oCAAA;AAiGA;;AA9FA;EACE,oCAAA;AAiGF;;AA/FA;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;AAkGF;;AA/FA;EACE,8BAAA;AAkGF;;AA/FA,+BAAA;AACA;EACI,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,mDAAA;AAkGJ;;AA/FA;EACE,yBAAA;AAkGF;;AAhGA;EACE,0BAAA;EACA,cAAA;AAmGF;;AAjGA;;EAEE,0BAAA;EACA,cAAA;AAoGF;;AAlGA;EACE,cAAA;AAqGF;;AAjGA;EACE,gBAAA;EACA,eAAA;AAoGF;;AAjGA;EACE,gBAAA;EACA,eAAA;AAoGF;;AAlGA;;EAEE,cAAA;AAqGF;;AAlGA,qCAAA;AACA;EACE,yEAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,mDAAA;AAqGF;;AAlGA;EACA,yBAAA;AAqGA;;AAnGA;EACA,0BAAA;EACA,cAAA;AAsGA;;AApGA;;EAEA,0BAAA;EACA,cAAA;AAuGA;;AArGA;EACA,cAAA;AAwGA;;AApGA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAuGA;;AApGA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAuGA;;AArGA;;EAEA,cAAA;AAwGA;;AArGA,mBAAA;AAEA;EACE,aAAA;EACA,uDAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;AAuGF;;AArGA;EACE,2CAAA;EACA,cAAA;AAwGF;;AArGA;EACE,0BAAA;AAwGF;;AArGA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAwGF;;AArGA;;;EAGE,uBAAA;EACA,aAAA;AAwGF;;AArGA;EACE,oEAAA;AAwGF;;AApGA;EACE,4BAAA;AAuGF;;AApGA;EACE,wBAAA;AAuGF;;AApGA;EACE,WAAA;AAuGF;;AApGA,qBAAA;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAsGF;;AAnGA;EACE,eAAA;AAsGF;;AApGA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAuGF;;AArGA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;AAwGF;;AArGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAwGF;;AArGA;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;AAwGF;;AArGA;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;AAwGF;;AAtGA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AAyGF;;AAvGA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA0GF;;AAvGA;EACE,iBAAA;AA0GF;;AAvGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AA0GF;;AAvGA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA0GF;;AAxGA;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AA2GF;;AAxGA;EACA,2BAAA;EACA,6BAAA;AA2GA;;AAxGA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA2GF;;AAtGA;EACE,aAAA;EACA,UAAA;EACA,8BAAA;EACA,aAAA;AAyGF;;AApGA;EACE,aAAA;EACA,sBAAA;AAuGF;;AApGA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAuGF;;AApGA;EACE,eAAA;EACA,gBAAA;AAuGF;;AArGA,wBAAA;AACA;EACE,aAAA;AAwGF;;AAtGA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;AAyGF;;AAvGA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,iCAAA;AA0GF;;AAvGA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA0GF;;AAxGA;EACE,eAAA;AA2GF;;AAzGA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;AA4GF;;AA1GA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,SAAA;EACF,kBAAA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AA6GF;;AA1GA;EACE,gBAAA;EACA,yBAAA;AA6GF;;AA3GA;EACE,yEAAA;EACA,cAAA;AA8GF;;AA5GA;EACE,yEAAA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AA+GJ;;AA7GA;EACE,eAAA;AAgHF;;AA5GA;EACE,UAAA;EACA,cAAA;AA+GF;;AA5GA;EACE,uBAAA;EACA,2BAAA;EACA,sDAAA;EACA;oBAAA;EAEA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,0BAAA;AA+GF;;AA7GA;EACE,aAAA,EAAA,iCAAA;EACA,sDAAA,EAAA,kCAAA;AAgHF;;AA7GA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAgHA;;AA9GA;EACE,uBAAA;EACA,UAAA;AAiHF;;AA7GA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AAgHF;AA/GI;EAEE,WAAA;EACA,YAAA;AAgHN;;AA7GA;EACE,8DAAA;EACA,yBAAA;AAgHF;;AA7GA,sBAAA;AAEA;EACE,oCAAA;EACA,8DAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AA+GF;;AA7GA;EACE,yEAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAgHF;;AA7GA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAgHF;;AA7GA;EACE,iBAAA;EACA,mDAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAgHF;;AA7GA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAgHF;;AA7GA;EACE,oFAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAgHF;;AA7GA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;AAgHF;;AA7GA;EACE,WAAA;EACA,YAAA;AAgHF;;AA9GA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAiHF;;AA7GA;EACE,aAAA;EACF,0DAAA;EACE,sBAAA;EACA,8BAAA;EACA,mBAAA;AAgHF;;AA9GA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAiHF;;AA/GA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;AAkHF;;AAhHA;EACE,kBAAA;EACA,YAAA;EACA,yBACA;EACF,gBAAA;EACE,0BAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AAkHF;;AAhHA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,oCACA;EACD,cAAA;EACA,eAAA;AAkHD;;AA9GA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AAiHF;;AA9GA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAiHF;;AA/GA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAkHF;;AAhHA;EACE,aAAA;EACA,cAAA;EACA,eAAA;AAmHF;;AAjHA;EACE,cAAA;AAoHF;;AAjHA;EACE,cAAA;AAoHF;;AAjHA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAoHA;;AAlHA;EACA,eAAA;EACA,cAAA;AAqHA;;AAlHA,8CAAA;AAEA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAoHF;;AAlHA;EACE,sBAAA;AAqHF;;AAlHA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;AAqHF;;AAnHA;EACI,mBAAA;EACA,YAAA;EAEA,kBAAA;EACA,YAAA;EACA,2CAAA;AAsHJ;;AAnHA;EACE,aAAA;EACA,sBAAA;AAsHF;;AAjHA,qCAAA;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;AAmHF;;AAhHA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAmHF;;AA/GA;EACE,6BAAA;EACA,QAAA;EACA,aAAA;AAkHF;;AA/GA,yBAAA;AACA;EACE,aAAA;AAkHF;;AAhHA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAmHF;;AAhHA;EACE,iBAAA;EACA,0BAAA;EACA,eAAA;AAmHF;;AAhHA;EACE,gBAAA;EACA,iBAAA;AAmHF;;AA9GA;EACE,aAAA;AAiHF;;AA9GA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAiHF;;AA/GA;EACE,eAAA;EACA,gBAAA;AAkHF;;AAhHA;EACE,WAAA;EACA,YAAA;AAmHF;;AAhHA;EACE,4CAAA;AAmHF;;AAhHA;EACE,aAAA;AAmHF;;AAhHA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAmHF;;AAhHA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yCAAA;EACA,SAAA;EACA,WAAA;AAmHF;;AAhHA;EACE,aAAA;AAmHF;;AAhHA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAmHF;;AAhHA;EACE,eAAA;EACA,gBAAA;EACA,qCAAA;AAmHF;;AAjHA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AAoHF;;AAjHA;EACE,aAAA;EACA,sBAAA;AAoHF;;AAjHA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAoHF;;AAlHA;EACE,cAAA;EACA,eAAA;AAqHF;;AAlHA;EACE,cAAA;AAqHF;;AAlHA;EACE,sBAAA;EACA,UAAA;EACA,qBAAA;AAqHF;;AAlHA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAqHF;;AAlHA;EACE,oFAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;AAqHF;;AAnHA,QAAA;AAEA,uBAAA;AACA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,SAAA;EACA,mBAAA;AAqHA;;AAlHA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;AAqHA;;AAlHE;EACE,yEAAA;EACJ,uBAAA;EACA,uBAAA;EACA,eAAA;AAqHA;;AAnHA,sBAAA;AAEM;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAqHR;;AAlHM;EACE,4CAAA;AAqHR;;AAlHM;EACF,yEAAA;EACA,yBAAA;EACI,eAAA;EACA,uBAAA;AAqHR;;AAlHM;EACE,gBAAA;AAqHR;;AAlHK;EACG,2BAAA;AAqHR;;AAlHM;EACE,2BAAA;AAqHR;;AAnHM;EACE,2BAAA;AAsHR;;AApHM;EACE,UAAA;EACA,2BAAA;AAuHR;;AApHM;EACE,6BAAA;EACA,uBAAA;EACA,YAAA;AAuHR;;AApHM;EACE,kBAAA;EACA,UAAA;AAuHR;;AArHI;EAEE,2CAAA;AAuHN;;AArHM;EACE,eAAA;EACA,UAAA;EACA,YAAA;AAwHR;;AAtHM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAyHR;;AAvHI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AA0HN","sourcesContent":["select.inputMain.form-select{\n  box-shadow: none;\n  border: none;\n  border-bottom: 1px solid #D0566E;\n  outline: none;\n  width: 170px;\n  border-radius: 0px;\n}\n\nselect.inputMain.form-select:focus {\n  outline: none; \n  border-bottom: 1px solid var(--hover-color) !important;\n}\ninput.inputMain.form-control{\n  box-shadow: none;\n  border: none;\n  border-bottom: 1px solid #D0566E;\n  outline: none;\n  width: 268px;\n  padding: 0px;\n  border-radius: 0px;\n  line-height: 1px;\n}\ninput.inputMain::placeholder {\n  color: var(--text-gray-color);\n}\ninput.inputMain.addLeads.form-control{\n  width: 170px;\n  padding-top: 10px;\n  padding-bottom: 4px;\n}\ninput.inputMain.search.form-control {\n  width: 50%;\n}\n.input-label.success.form-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--success-green-color);\n}\n.input-label.error.form-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--error-red-color);\n}\n.input-label.cabin.form-text {\n  color: #000000;\n}\n.input-label.form-text {\n  font-size: 16px;\n  font-weight: 400;\n}\n.port-text-font.form-text, .discount-text-font.form-text {\n  font-size: 12px;\n  font-weight: 400;\n  margin-top: 0px;\n}\n\n.discount-text-font.form-text{\n  color: #17A300\n}\n\n.textBox {\n  display: flex;\n  justify-content: flex-end;\n}\n.mainBtn {\n  background: var(--main-btn) !important;\n  color: var(--background-color) !important;\n  border: none !important;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  transition: background-color 0.3s ease !important;\n  text-transform: none !important;\n}\n\n.mainBtn:hover{\n  background-color:#b63f48!important;\n}\n\n.mainBtn.loginBtn {\n  max-width: 150px;\n}\n.mainBtn.createBtn {\n  width: 10rem;\n  max-height: 2.2rem;\n}\n.mainBtn.Grey-Btn {\n  width: 10rem;\n  background: var(--text-grayBtn-color) !important;\n  color:var(--primary-font-color) !important;\n}\n\n.mainHead{\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\nbutton#RFS-StepButton.active {\n  background-color: var(--hover-color)  !important;\n}\nbutton#RFS-StepButton.completed {\n  background-color: var(--hover-color)  !important;\n}\n.main-heading.form-text {\n  font-size: 20px;\n  font-weight: 700;\n}\n.inputMain.quotation.form-select {\n  width: 465px !important;\n}\n.inputMain.select-guest.form-select {\n  max-width: 75px;\n}\n/* .quotation-checkbox label {\n  color: black;\n} */\n\n\n.quotation-checkbox .form-check-input:checked {\n  border-color: var(--hover-color); \n  background-color: var(--hover-color); \n}\n.form-check-input:focus{\n  border-color: #ddd!important;\n  box-shadow: none!important;\n}\nsmall.input-label.quotation.form-text {\n  font-size: 14px;\n  color: #7A7A7A;\n}\n.input-label.success.text.form-text {\n  font-size: 14px;\n}\n.cabin-view {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.input-label.cabin.form-text {\n  font-size: 16px;\n  font-weight: 500;\n}\n.input-label.cabinPrice.form-text {\n  font-size: 20px;\n  font-weight: 500;\n  color:var(--primary-font-color);\n  display: flex;\n  justify-content: flex-end;\n}\n.mainBtn.cabinBtn{\n  height: 36px !important;\n  width: 36px;\n}\n.form-control:disabled {\n   background-color: none !important;\n}\n\n\n/* base Classes end */\n\n/* quotation start */\n.select-quest-box.row {\n  padding: 0px 0px 16px 0px;\n  border-bottom: 1px solid gainsboro;\n  flex-wrap: wrap;\n}\n.quotation-checkbox.form-check {\n  font-size: 14px;\n}\n.quotation-heading.form-text {\n  font-size: 18px;\n  font-weight: 700;\n}\n.cabin-pricing {\n  cursor: pointer;\n  border-bottom: 1px solid var(--text-gray-color);\n  .cabin-detail-wrapper{\n    border-bottom: 1px solid #ddd;\n    &:has(.cabin-guest-wrapper){\n      padding-bottom: 0!important;\n    }\n  }\n}\n.collapsed-content {\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2); \n}\n.cabinContent {\n  display: flex;\n  gap: 9px;\n  justify-content: flex-end;\n}\n.input-label.error.text.form-text {\n  font-size: 14px;\n}\n.selling-box{\n  // height: 341px;\n  overflow-x: hidden;\n}\n.selling-box::-webkit-scrollbar {\n  display: none;\n}\n\n.selling-box {\n  -ms-overflow-style: none; \n  scrollbar-width: none; \n}\n.input-label.price-text.form-text {\n  font-size: 16px;\n  font-weight: 700;\n}\n.input-label.select-guest.form-text {\n  font-weight: 500;\n  display: flex;\n  color: var(--hover-color);\n  align-items: center;\n  gap: 4px;\n  cursor:pointer\n}\n\n.invoice{\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n}\n/* quotation end */\n\n\n.stepStyleActive{\n  color: var(--hover-color);\n}\n.stepperBoxContent {\n  min-width: 60%;\n}\n.stepperBoxHead {\n  display: flex;\n  justify-content: center;\n}\n\n/* basic detail page css  */\n.basic-detail-page{\nbackground-color: var(--background-color);\n}\n.btn-box {\n  padding-right: 44px;\n  display: flex;\n  justify-content: flex-end;\n}\n.card-content.card {\n  padding: 28px;\n}\n.autoComplete {\n  display: flex;\n  gap: 131px;\n}\n.autoComplete-data {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.addleads {\n  margin-right: 31px;\n}\n.select-box {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\ntr.tableRow {\n  cursor: pointer;\n}\ntr.tableRow:hover {\n  background:#f3f3f3;\n}\nthead{\n  line-height: 2;\n  font-weight: 400 !important;\n  color: #7A7A7A !important;\n  margin-bottom: 4px !important;\n  border-bottom: 1px solid #d7d7d7 !important;\n}\n\n\nsmall.input-label-check.form-text {\n  font-size: 12px;\n}\n.check-num {\n  display: flex;\n  /* font-size: 21px; */\n  gap: 6px;\n  padding-top: 12px;\n  align-items: center;\n}\n.status.Active.form-text {\n  font-size: 17px;\n  font-weight: 500;\n  color: #17A300;\n}\n.status.Inactive.form-text {\n  font-size: 17px;\n  margin-top: 14px;\n  font-weight: 500;\n  color:#D40D0D;\n}\n\n.card-content.preview.card {\n  padding: 7px 28px;\n}\n\n.closeBtnBox {\n  display: flex;\n  justify-content: flex-end;\n}\n.moreInfo {\n  padding: 24px;\n}\n.special-services {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 11px;\n  margin: 10px 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Login Page Css  start */\n.loginPage {\n  height: 100%;\n  width: 100%;\n}\n.loginPageContent {\n  padding: 47px 40px;\n  position: absolute;\n  top: 0;\n  background: #fff;\n  border-radius: 23px;\n  margin: 150px;\n}\n.carouselBox {\n  position: relative;\n}\n.fontText.back {\n  color: var(--text-darkgray-color);\n  line-height: 2;\n}\n.fontText.back:hover{\n  color: var(--hover-color);\n}\n.imageBox {\n  margin: 4px 54px;\n}\n\n.loginInputsBox {\n  background-color: var(--background-color);\n  padding: 37px 0px 28px 0px;\n  border-radius: 27px;\n  margin: 61px;\n  width: 348px;\n}\n\n.loginInputs {\n  background: var(--background-color);\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n.detailBox.select {\n  display: flex;\n  align-items: baseline;\n  gap: 21px;\n}\n.selectInputs {\n  width: 185px;\n}\n.fontText {\n  text-align: end;\n  color: var(--text-gray-color) !important;\n  cursor: pointer;\n  font-size: 14px !important;\n}\n.inputHead {\n  font-size: 16px;\n  color:var(--primary-font-color);\n  font-family: var(--dm-font);\n}\n.fontText.text {\n  text-align: start;\n  font-size: 18px;\n  font-weight: 500;\n}\n.fontText.resetText {\n  font-size: 18px;\n  color: var(--text-darkgray-color);\n  text-align: justify;\n}\n\n.textInputs .MuiOutlinedInput-root fieldset {\n  border-color: transparent; /* Remove outline */\n}\n\n.textInputs .MuiOutlinedInput-root:hover fieldset {\n  border-color: var(--hover-color); /* Change hover color */\n}\n\n.textInputs {\n  margin-top: 20px !important;\n}\n.textInputs.text {\n  margin-top: 9px;\n  color:var(--primary-font-color);\n}\n.textInputs .MuiInput-underline:before {\n  border-bottom: 1px solid var(--hover-color);\n}\n.textInputs .MuiInput-underline:hover:before {\n  border-bottom: 1px solid var(--hover-color) ;\n}\n\n.textInputs .MuiInput-underline:hover:after {\n  border-bottom: 2px solid var(--hover-color) !important;\n  transition: border-bottom-color 0.2s ease-in-out;\n}\n\n.textInputs .MuiInput-underline:after {\n  border-bottom: 1px solid var(--hover-color);\n}\n\n.textInputs .MuiInput-root:hover .MuiInput-underline:after {\n  border-bottom-color: var(--hover-color) !important;\n}\n.textInputs .MuiInput-underline:before {\n  border-bottom: 1px solid var(--hover-color);\n}\n.textInputs .MuiInput-underline:hover:before {\n  border-bottom: 1px solid var(--hover-color) !important;\n}\n\n.customCheckbox {\n  color: var(--text-gray-color) !important;\n}\n\n.customCheckbox.Mui-checked {\n  color: var(--text-gray-color) !important;\n}\n.rememberMe {\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n  color: var(--text-gray-color);\n}\n\n.loginContent {\n  display: flex;\n  flex-direction: column;\n  gap: 60px;\n  margin: 0px 32px 0px 30p\n}\n\n\n\n.btnBox {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 34px;\n} \n\n/* Responsive Layout */\n@media (max-width: 768px) {\n  .login-page {\n    padding: 50px 10px;\n  }\n\n  .loginInputsBox {\n    margin: 20px 10px;\n  }\n}\n\n.headerContent {\n  background: linear-gradient(to right, var(--secondary-color), var(--primary-color));\n  height: 107px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 28px 41px 1px 26px;\n}\n.basicDetailPage {\n  padding: 9px 74px;\n}\n\n.basicDetailContent {\n  display: flex;\n  gap: 68px;\n  padding-top: 65px;\n}\n.textInputs.search {\n  width: 50%;\n}\n.textInputs.profile{\n  margin-top: 0px;\n}\n.rememberMe.text {\n  margin: 6px 0px 0px -23px;\n}\n.textHead {\n  font-size: 14px;\n}\n.form-text.errorText {\n  font-size: 13px;\n  color: red;\n  max-width: 268px;\n}\n.inputSection {\n  max-width: 268px;\n}\n.headText {\n  color: var(--text-darkgray-color);\n  text-align: end;\n  margin-top: 40px;\n}\n\n/* Stepper Css Start  */\n\n.stepperBox {\n  \n  width: 100%; /* make the box take up the full width of the container */\n}\n.stepperBoxHeader{\n  width:0%\n}\n/* .selectInputs .MuiSelect-root {\n  color: #6F1F67; \n} */\n\n.selectInputs input {\n  caret-color: white; /* Change caret color */\n  color: white; /* Change text color */\n}\n\n.selectInputs .MuiSelect-icon {\n  color: gray;\n}\n.mainLogo {\n  padding: 33px;\n  margin: 0px 25px;\n  cursor: pointer;\n}\n\n/* Itenerary SelectionPage css     */\n \n.itenerarySelectionPage{\n  padding: 9px 53px;\n}\n.selectInputs.multiSelect{\n  max-width: 165px;\n}\n.itenerarySelectionContent{\n  display: flex;\n  gap: 3px;\n}\n.iteneraryText {\n  font-size: 22px !important;\n  font-weight: 600 !important;\n  margin-top: 19px !important;\n}\n\n.searchBox {\n  /* border-bottom: 1px solid var(--hover-color); */\n  margin-top: 18px;\n  box-shadow: 0px 5px 5px -5px rgba(208, 86, 110, 0.5);\n}\ntd.tableContent {\n  padding-bottom: 12px;\n}\nth.tableContent {\n  font-weight: 400;\n}\n\n.searchHead {\n  justify-content: space-between;\n  display: flex;\n  background-color: #F9FFF2;\n  padding: 6px 26px;\n}\n.inputHead.dataText{\n  font-weight: 600;\n}\n.searchDataContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  color: var(--primary-font-color);\n  background-color: #F9FFF2;\n  padding: 21px 21px;\n  margin: 4px 0px;\n}\n.dateBox{\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.basic-detail-page thead {\n  border-bottom: 1px solid lightgray;\n}\n\n.searchHide{\n  padding: 7px 27px;\n  color: var(--text-darkgray-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.accordianBar {\n  display: flex;\n  color: #C1517A;\n  font-weight: 500;\n  cursor: pointer;\n}\n.accordianBar.hide {\n  display: flex;\n  font-weight: 500;\n  cursor: pointer;\n  color:var(--primary-font-color)\n}\n.accordianBar:hover {\n  color: #852b4c;\n}\n\n.grayBtn{\n  width: 150px !important;\n  background: var(--text-grayBtn-color) !important;\n  color: var(--primary-font-color) !important;\n}\n.status { \n  font-weight: 500;\n}\n.status .confirmed{\n  color: #17A300;\n  font-weight: 500;\n}\n.status .onhold{\n  color: #D07D00;\n  font-weight: 500;\n}\n.status .Cancelled{\n  color: #D40D0D;\n  font-weight: 500;\n}\n.status .Rescheduled{\n  color: #0D2DD4;\n  font-weight: 500;\n}\n\n.closeTag {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  cursor: pointer;\n  margin-bottom: 23px;\n}\n.closeIcon {\n  background-color: beige;\n  color: gray;\n}\n.dateTxt {\n  font-size: 14px;\n}\n.btnBoxModal{\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.modalBtn{\n  width: 100% !important;  \n}\n.modalBox{\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.modalContent{\n  margin: 1px 74px;\n}\n.timelineMainHead {\n  display: flex;\n  gap: 34%;\n  margin: 52px 75px;\n}\n.timelineHead{\n    font-size: 20px;\n    font-weight: 500;\n}\n.fontText.modalText {\n  text-align: start;\n}\n\n.timelineMain{\n  display: flex;\n  gap: 29px;\n  margin:-23px 14px 0px 85px;\n} \n.timelineMain:hover {\n \n  color:var(--hover-color)!important;\n  cursor: pointer;\n}\n.timelineMainContent{\n  display: flex;\n  gap: 25px;\n}\n.dateBox.iconLogo{\n  align-items: end;\n}\n\n\n/* profile page css */\n\n.profileContent{\n  margin: 7px 31px;\n}\n\n/* create Staff css */\n.createStaffContent{\n  margin: 7px 31px;\n  height: 100vh;\n}\n\n.inputHead.headTextt{\n  font-weight: 500;\n}\n\n.selectInputs.createSelect{\n  width: 100%;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n.editIcon{\n  cursor: pointer;\n  color: darkgray;\n}\n.MuiDataGrid-withBorderColor{\n  outline: none !important;\n}\n.MuiDataGrid-cell.MuiDataGrid-cell--textLeft.MuiDataGrid-withBorderColor {\n  outline: none !important;\n}\n.inputHead.permission{\n  padding: 9px;\n}\n.rolesCheck {\ncolor: var(--hover-color) !important;\n}\n\n.rolesCheck.Mui-checked {\n  color: var(--hover-color) !important;\n}\n.headerProfile {\n  margin-left: auto;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.MuiDataGrid-columnHeaders.MuiDataGrid-withBorderColor.css-y599qu {\n  background: #f3f3f3 !important;\n}\n\n/* add lead details container */\n.lead-details{\n    background:#fff ;\n    height: 170px;\n    margin-top: 40px !important;\n    border-radius: 7px;\n    margin-right: 40px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    padding: 10px;\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n    border: 1px solid #7a7a7a67;\n}\n\n.lead-details:hover{\n  border: 1px solid #DB686E;\n}\n.lead-details-icon{\n  font-size: 50px !important;\n  color: #3A3A3A;\n}\n.lead-details-icon.active,\n.lead-details-icon:hover{\n  font-size: 50px !important;\n  color: #3A3A3A;\n}\n.lead-details:hover .lead-details-icon{\n  color: #DB686E;\n}\n\n\n.lead-details h3{\n  font-weight: 700;\n  font-size: 58px;\n}\n\n.lead-details h6{\n  font-weight: 500;\n  font-size: 15px;\n}\n.lead-details:hover h6,\n.lead-details:hover h3{\n  color: #DB686E ;\n}\n\n/* add lead details container first */\n.lead-details-first{\n  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) ;\n  height: 170px;\n  margin-top: 40px !important;\n  border-radius: 7px;\n  margin-right: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n  border: 1px solid #7a7a7a67;\n}\n\n.lead-details-first:hover{\nborder: 1px solid #DB686E;\n}\n.lead-details-first-icon{\nfont-size: 50px !important;\ncolor: #ffffff;\n}\n.lead-details-first-icon.active,\n.lead-details-icon:hover{\nfont-size: 50px !important;\ncolor: #ffffff;\n}\n.lead-details-first:hover .lead-details-first-icon{\ncolor: #ffffff;\n}\n\n\n.lead-details-first h3{\nfont-weight: 700;\nfont-size: 58px;\ncolor: #ffffff ;\n}\n\n.lead-details-first h6{\nfont-weight: 500;\nfont-size: 16px;\ncolor: #ffffff ;\n}\n.lead-details-first:hover h6,\n.lead-details-first:hover h3{\ncolor: #ffffff ;\n}\n\n/* dashboard page */\n\n.dashboard-header-search{\n  display: flex;\n  border-bottom: 1px solid #55555549;\n  padding: 5px;\n  align-items: center;\n  justify-content: flex-start;\n  width: 60% !important ;\n}\n.dashboard-header-search.leads{\n  border-bottom: 1px solid var(--hover-color);\n  max-width: 50%;\n}\n\n.dashboard-header-search-icon{\n  font-size: 20px !important;\n}\n\n.dashboard-header-search-input{\n  width: 100%;\n  margin-left: 10px;\n  border: none;\n  background: none;\n  color: #7A7A7A;\n}\n\n.dashboard-header-search-input:active,\n.dashboard-header-search-input:focus,\n.dashboard-header-search-input:focus-visible{\n  border: none !important;\n  outline: none;\n}\n\n.a{\n  color: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\n}\n\n\n.hidden {\n  transform: translateX(-100%);\n}\n\n.visible {\n  transform: translateX(0);\n}\n\n.sidebar .nav-link:hover {\n  color: #fff;\n}\n\n/* Itinerary cards  */\n\n.recent-card-content{\n  display: flex;\n  border: 1px solid #DDDDDD;\n  border-radius: 7px;\n  flex-direction: column;\n  background: #FCFCFC;\n  position: relative;\n  top: 18px;\n}\n\n.recent-card-content-footer.row {\n  margin: 0px 8px;\n}\n.recent-card-content-bottom.col-sm-4.col-12 {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 25px;\n}\n.recent-card-content-header{\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 7px;\n  padding-top: 5px;\n  border-bottom: 1px solid #DDDDDD;\n  background-color: #F9FFF2;\n}\n\n.recent-card-content-header div{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n}\n.recent-card-content-header div h3:first-child{\n  color: #92278F;\n  font-size: 13px;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n\n}\n.recent-card-content-header div span{\n  color:#17A300;\n  font-size: 13px;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.recent-card-content-header h3{\n  font-size: 16px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\nh3.status-text {\n  color: #17A300 !important;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.recent-card-content-header span{\n  margin-left: 10px;\n}\n\n.recent-card-content-body{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n}\n\n.recent-card-content-body-box{\n  display: flex;\n  gap: 7px;\n  align-items: center;\n}\n.recent-card-content-body-box span{\n  color: #7A7A7A;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n}\n.container-fluid{\n--bs-gutter-x: 0 !important;\noverflow-x: hidden !important;\n}\n\n.recent-card-content-body-box-details-btn{\n  border: none;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 300;\n  padding: 7px 13px;\n  color: #3A3A3A;\n}\n\n\n\n.recent-card-content-body-bottom {\n  display: flex;\n  width: 80%;\n  justify-content: space-between;\n  padding: 20px;\n  \n}\n\n\n.recent-card-content-body-bottom-box{\n  display: flex;\n  flex-direction: column;\n\n}\n.recent-card-content-body-bottom-box span {\n  display: flex;\n  flex-direction: column;\n  color: #7A7A7A;\n  font-size: 14px;\n}\n\nspan.card-content {\n  font-size: 14px;\n  font-weight: 700;\n}\n/*collapsible  side bar*/\n.container-sidebar{\n  display:flex;\n}\nmain {\n  width: 100%;\n  background: #F7F7F7;\n  padding: 0px 26px;\n}\n.sidebar {\n  position: relative;\n  background: #fff;\n  color: #000;\n  height: 100vh;\n  width: 250px;\n  transition: all 0.04s ease-in-out; \n}\n\n.top_section{\n  display: flex;\n  align-items:center;\n  padding:20px 15px;\n  margin-bottom: 20px;\n}\n.logo{\n  font-size: 30px;\n}\n.bars{\n  display: flex;\n  font-size: 25px;\n  margin-left: 50px;\n  position: unset;\n  left: 68%;\n}\n.link{\n  color: #3A3A3A;\n  padding: 10px 15px;\n  border-radius: 5px;\n  width: 100% !important;\n  height: 40px;\n  gap: 12px;\ntext-align: center;\n  display: flex;\n  /* align-items: center; */\n  height: 40px;\n  text-decoration: none;\n  cursor: pointer;\n  \n}\n.link:hover{\n  background:#fff;\n  color:var(--hover-color);\n}\n.link.active{\n  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\n  color: #fafafa;\n}\n.menu-item::hover{\n  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n}\n.icon, .link_text{\n  font-size: 14px;\n}\n\n\n.custom-slider {\n  width: 70%;\n  margin: 0 auto;\n}\n\n.itneries-select {\n  border: none !important;\n  border-radius: 0 !important;\n  border-bottom: 1px solid var(--hover-color) !important;\n  /* padding: 0 !important;\n  margin-top: 7px; */\n  position: relative;\n  top: 22%;\n  color: #b4b3b3 !important;\n  font-size: 16px !important;\n}\nselect.itneries-select.form-select:focus {\n  outline: none; /* Remove default focus outline */\n  border-bottom: 1px solid var(--hover-color) !important; /* Maintain custom border-bottom */\n}\n\n.select-label{\nfont-size: 16px !important;\nfont-weight: 400;\ncolor: #3A3A3A;\n}\n.form-select:focus {\n  border: none !important;\n  outline: 0 ;\n  \n}\n\n.itneries-links{\n  display: flex;\n  gap: 15px;\n  margin-left: 20px;\n  align-items: center;\n    span{\n\n      width:41px;\n      height: 40px;\n    }\n}\n.nav-link{\n  border: 1px solid  #C5C5C580 !important;\n  color:  #BBBBBB !important;\n}\n\n/* select nights tabs*/\n\n.selected-tabs{\n  background-color: #ffffff !important;\n  border: 1px solid #C5C5C580 !important;\n  margin-left: 10px;\n  color: #BBBBBB !important;\n  padding: 8px 11px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.selected-tabs-active{\n  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\n  border: none !important;\n  margin-left: 10px;\n  color: #ffffff !important;\n  padding: 8px 11px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.itneries-links-chips{\n  display: flex;\n  gap: 5px;\n  margin-top: 25px;\n}\n\n.itneries-links-chips p{\n  padding: 4px 11px;\n  background-color: #9b9b9b2c;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.itneries-button-check-availibity{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n}\n.itneries-button-check-availibity-button{\n  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) !important;\n  border: 0;\n  border: none !important;\n  font-size: 16px;\n}\n\n.itneries-button-preview-button{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-content: flex-end;\n  position: relative;\n  top: 20%;\n}\n\n.itneries-button-check-availibity a{\n  width: auto;\n  height: auto;\n}\n.recent-card-content-itnery-body.col-sm-9.col-12 {\n  display: flex;\n  justify-content: space-between;\n  padding: 13px 33px;\n}\n\n\n.itneries-table-card-top{\n  display: flex;\nborder-bottom: 1px solid  #C5C5C580;\n  width: 100% !important;\n  justify-content: space-between;\n  align-items: center;\n}\n.itneries-table-card-top h5{\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n  margin-top: 8px !important;\n}\n.itneries-table-item{\n  overflow: hidden;\n  border-radius: 2px;\n  box-sizing: border-box;\n}\n.itneries-table-card-top-span-01{\n  padding: 10px 34px;\n  height: 100%;\n  background-color: \n  #C8F5FF;\nfont-weight: 500;\n  text-transform: capitalize;\n  color: #1E1E1E ;\n  font-size: 16px;\n  margin: 0;\n}\n.itneries-table-card-top-span-02{\n  padding: 10px 34px;\n  height: 100%;\n  font-weight: 500;\n  background-color: \n  #F6C1FF !important;\n color: #1E1E1E ;\n font-size: 16px;\n\n}\n\n.exchange-destination-icon{\n  cursor: pointer;\n  padding: 4px;\n  position: relative;\n\n}\n.itneries-table-checkbox{\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n.itneries-table-card-bottom{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n}\n.itneries-table-card-bottom span{\n  padding: 10px ;\n  color: #7A7A7A;\n  font-size: 16px;\n}\n.itneries-table-card-bottom span:nth-child(2) {\n  color: #C35379;\n}\n\n.itneries-table-card-bottom span:nth-child(5) {\n  color: #92278F;\n}\n\n.itneries-table-head{\ndisplay: flex;\nalign-items: center;\njustify-content: space-around;\nflex-direction: row;\nbackground: #F8F7F7;\nborder-radius: 6px;\nheight: 30px;\nmargin-bottom: 15px;\n}\n.itneries-table-head span{\nfont-size: 14px;\ncolor: #3A3A3A;\n  \n}\n/* react date range picker css custmomization*/\n\n.rdrDateRangeWrapper {\n  z-index: 9999;\n  position: absolute;\n  width: 700px;\n  border: 1px solid #f7f7f7;\n  margin-top: 20px;\n  box-shadow: #f7f7f7;\n}\n.rdrDefinedRangesWrapper{\n  background-color: blue;\n}\n\n.select-range-button{\n  position: relative;\n  top: 38%;\n  display: flex;\n}\n.select-range-button input {\n    border-radius: none;\n    border: none;\n    width: -moz-fit-content;\n    width: fit-content;\n    height: 24px;\n    border-bottom: 1px solid var(--hover-color);\n}\n\n.select-range-button span{\n  display: flex;\n  justify-content: right;\n}\n\n\n\n/* header right side profile popup  */\n\n.profile-popup {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  top: 32%;\n  cursor: pointer;\n  right: 10px;\n  transition: opacity 0.3s ease-in-out; \n}\n\n.profile-popup-content {\n  background-color: #fff;\n  padding: 10px;\n  border-radius: 3px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  position: absolute;\n  z-index: 9999;\n  font-size: 14px;\n  color: #3A3A3A;\n\n}\n\n.profile-popup-content p {\n  margin-bottom: 8px !important;\n  gap: 7px;\n  display: flex;\n\n}\n/* preview modal detail */\n.preview-model-details{\n  display: flex;\n}\n.preview-model-details-box {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 30px;\n}\n\n.preview-model-details-box span:first-child{\n  font-weight: bold;\n  text-transform: capitalize;\n  font-size: 17px;\n}\n\n.preview-model-details-box span:nth-child(2){\n  font-weight: 500;\n  line-height: 30px;\n}\n\n\n\n.preview-model-visite {\n  display: flex;\n}\n\n.preview-model-visite-item{\n  padding-right: 40px;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.preview-model-visite-item span{\n  font-size: 14px;\n  font-weight: 400;\n}\n.preview-model-visite-item svg{\n  width: 20px;\n  height: 20px;\n}\n\n.hr-color{\n  border: 1px solid rgba(138, 138, 138, 0.545);\n}\n\n.model-details-cards{\n  display: flex;\n  \n}\n.model-details-cards-box{\n  padding-top: 20px;\n  padding-right: 90px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.model-details-cards-box::after{\n  content: \"\";\n  position: absolute;\n  width: 40px;\n  height: 1px;\n  background-color: rgba(15, 10, 10, 0.522);\n  top: 35px;\n  right: 22px;\n}\n\n.model-details-cards-box:last-child:after{\n  display: none;\n}\n\n.model-details-cards-box svg{\n  width: 25px;\n  height: 25px;\n  margin-right: 5px;\n}\n\n.model-available-cabins h4{\n  font-size: 18px;\n  font-weight: 700;\n  color: #1b1212cf;\n}\n.model-available-cabins{\n  display: flex;\n  gap: 40px;\n  justify-content: space-between;\n}\n\n.model-available-cabins-box{\n  display: flex;\n  flex-direction: column;\n}\n\n.model-available-cabins-box span:first-child{\n  font-size: 18px;\n  font-weight: 500;\n  color: #e12d6f;\n}\n.model-available-cabins-box span:nth-child(2){\n  color: #b91d1d;\n  font-size: 14px;\n}\n\n.model-available-cabins-box span.more-than-10{\n  color: #17A300;\n}\n\ninput[type=\"checkbox\"] {  \n  box-sizing: border-box;\n  padding: 0;\n  accent-color: #673ab7;\n}\n\n.preview-itneries-buttons{\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 20px;\n  top: 20px;\n  padding: 0px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n}\n.preview-itneries-buttons-button{\n  background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%) !important;\n  border: 0;\n  border: none !important;\n  font-size: 16px;\n  padding: 10px 50px !important;\n}\n/* end */\n\n/* ---success modal---*/\n.success-modal-button-container{\ndisplay: flex;\njustify-content: center;\npadding: 29px 10px 17px 10px;\ngap: 20px;\nmargin-bottom: 20px;\n}\n\n.success-modal-button-container  button:nth-child(1){\nbackground-color: rgb(228, 228, 228);\npadding: 10px 26px 10px;\nfont-size: 13px;\nborder: none !important;\ncolor: #3a3a3a;\n  }\n\n  .success-modal-button-container  button:nth-child(2){\n    background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\nborder: none !important;\npadding: 10px 26px 10px;\nfont-size: 13px;\n      }\n/* All bookings tabs */\n\n      .nav-tabs .nav-link {\n        border-radius: 6px;\n        background: #e9e9e9;\n        color: #3A3A3A !important;\n        font-size: 16px;\n      }\n\n      .nav-tabs {\n        --bs-nav-tabs-border-width: none !important\n      }\n\n      .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n    background: linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%);\n    color: #ffffff !important;\n        font-size: 16px;\n        border: none !important;\n      }\n\n      .all-bookings-active{\n        background: none;\n      }\n\n     .nav-link:focus-visible{\n        box-shadow: none !important;\n      }\n    \n      .form-control:disabled {\n        background: none !important;\n      }\n      input.inputMain.form-control:disabled {\n        background: none !important;\n      }\n      .form-select:focus {\n        outline: 0;\n        box-shadow: none !important\n      }\n\n      .itneries-select option {\n        background-color: transparent; \n        border: none !important; \n        color: black; \n      }\n      \n      .calenderIcon {\n        position: absolute;\n        right: 5px;\n    }\n    select.itneries-select.valueSelect.form-select {\n\n      color: var(--primary-font-color) !important;\n    }\n      .error-msg-text{\n        font-size:  12px ; \n        color: red;\n        padding: 3px;\n      }\n      .roundClass {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    } \n    .booking-text {\n      color: #92278F;\n      font-size: 16px;\n      font-weight: 700;\n      margin-top: 15px;\n      text-transform: uppercase;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
